import { c as _c } from "react/compiler-runtime";
import { useVillaSearchPassengerCount } from "@website/accommodation-ui/villa-search/villa-search-passenger-count/villa-search-passenger-count.hook";
import { VillaSearchPassengerCountPropertiesType } from "@website/accommodation-ui/villa-search/villa-search-passenger-count/villa-search-passenger-count.types";
import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Chips } from "@website/ui/chips";
import { ListItem } from "@website/ui/list-item";
import { MiniChips } from "@website/ui/mini-chips";
import { MiniPopover } from "@website/ui/mini-popover";
import { TextField } from "@website/ui/text-field";
import { FC } from "react";
export const VillaSearchPassengerCount: FC<VillaSearchPassengerCountPropertiesType> = properties => {
  const $ = _c(30);
  const {
    searchType,
    size
  } = properties;
  const {
    list,
    chipsProps,
    popoverProps,
    submitButtonProps,
    miniChipsPassenger,
    miniChipsChildren,
    validation
  } = useVillaSearchPassengerCount(properties);
  const {
    isMobile
  } = useViewPort();
  let t0;
  if ($[0] !== chipsProps || $[1] !== isMobile || $[2] !== searchType || $[3] !== size) {
    t0 = searchType === "villa" ? <TextField EndIcon={<MaterialIcon name="arrow_drop_down" />} StartIcon={<MaterialIcon name="group" variant="outlined" />} className="text-on-surface-medium-emphasis" fullWidth={true} hasFocusStyle={!isMobile} inputMode="none" label={"\u062A\u0639\u062F\u0627\u062F \u0645\u0633\u0627\u0641\u0631"} onClick={chipsProps.onClick} size={size} value={chipsProps.text} /> : <Chips {...chipsProps} />;
    $[0] = chipsProps;
    $[1] = isMobile;
    $[2] = searchType;
    $[3] = size;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== list) {
    t1 = list.map(_temp);
    $[5] = list;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <div className="flex flex-1 overflow-hidden"><div className="flex-1 overflow-y-auto">{t1}</div></div>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== miniChipsPassenger || $[10] !== validation.isPassengerDisabled) {
    t3 = validation.isPassengerDisabled && <div className="text-caption px-4 pt-7"><MiniChips StartIcon={<MaterialIcon className="text-base" name="info" variant="outlined" />} color="error" text={miniChipsPassenger.text} variant="text" /></div>;
    $[9] = miniChipsPassenger;
    $[10] = validation.isPassengerDisabled;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== miniChipsChildren || $[13] !== validation.isChildrenDisabled || $[14] !== validation.isPassengerDisabled) {
    t4 = validation.isChildrenDisabled && !validation.isPassengerDisabled && <div className="text-caption px-4 pt-7"><MiniChips StartIcon={<MaterialIcon className="text-base" name="info" variant="outlined" />} color="error" text={miniChipsChildren.text} variant="text" /></div>;
    $[12] = miniChipsChildren;
    $[13] = validation.isChildrenDisabled;
    $[14] = validation.isPassengerDisabled;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== submitButtonProps || $[17] !== validation.isSubmitDisabled) {
    t5 = <div className="px-6 pb-6 pt-5"><Button disabled={validation.isSubmitDisabled} {...submitButtonProps}>{submitButtonProps.submitText}</Button></div>;
    $[16] = submitButtonProps;
    $[17] = validation.isSubmitDisabled;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t2 || $[20] !== t3 || $[21] !== t4 || $[22] !== t5) {
    t6 = <div className="flex flex-1 flex-col overflow-hidden">{t2}{t3}{t4}{t5}</div>;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== popoverProps || $[25] !== t6) {
    t7 = <MiniPopover {...popoverProps}>{t6}</MiniPopover>;
    $[24] = popoverProps;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== t0 || $[28] !== t7) {
    t8 = <div className="relative">{t0}{t7}</div>;
    $[27] = t0;
    $[28] = t7;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  return t8;
};
function _temp(item) {
  return <ListItem key={item.title} {...item} />;
}